import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row } from 'antd';

import * as actions from '../../actions';
import { formatProgress } from '../../util/formatProgress';
import Breadcrumbs from './Breadcrumbs';
import ProviderTypeModal from '../ProviderTypeModal';
import QuickLinks from './QuickLinks';

class DashboardHeader extends Component {
  static displayName = 'DashboardHeader';

  constructor(props) {
    super(props);
    this.state = {
      page: this.props.sq.state.page,
    };
  }

  componentDidMount() {
    const { updateProgress } = this.props;
    const componentProgress = formatProgress(this.constructor.displayName, true);
    updateProgress(componentProgress);
  }

  componentDidUpdate() {
    // If page_lineage does not contain current page crumb update
    const crumbName = this.props.providerDetails.name;
    const crumbList = this.props.sq.state.page.page_lineage.filter(
      crumb => crumb.asset_name === crumbName
    );
    const lastCrumb = {
      asset_assetid: '',
      asset_name: crumbName,
      asset_url: window.location.href
    };
    const copyState = { ...this.state };

    if (!crumbList.length && crumbName) {
      copyState.page.page_lineage.push(lastCrumb);
      this.setState({
        ...copyState
      });
    }
  }

  render() {
    const {
      providerDetails: { quickLinks, banner, slug },
      isMobile,
      openCurrentProcessInfo
    } = this.props;
    const { page } = this.state;
    return (
      <div
        id="banner"
        className="banner page-header page-header--provider"
        style={{ backgroundImage: `url('${banner}')` }}
      >
        <div
          className="page-header__overlay page-header__overlay--provider"
          style={{
            backgroundColor: `rgba(0, 0, 0, ${page.page_header_opacity})`
          }}
        ></div>
        <Row className="fixed">

          <div className="page-breadcrumb__padout"></div>
          <div role="banner" className="page-header__wrapper">
            <ProviderTypeModal />
            {quickLinks ? (
              <QuickLinks
                quickLinks={quickLinks}
                isMobile={isMobile}
                providerName={slug}
                openCurrentProcessInfo={openCurrentProcessInfo}
              />
            ) : null}
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isMobile: state.app.isMobile,
    progress: state.app.progress,
    providerDetails: state.providerDetails.data,
  };
};

const mapDispatchToProps = dispatch => ({
  openCurrentProcessInfo: () =>
    dispatch(actions.currentProviderActions.openCurrentProcessInfo()),
  updateProgress: progress =>
    dispatch(actions.appActions.updateProgress(progress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardHeader);
